import React from 'react';
import { Card } from '../ui/Card';
import { TaskList } from '../tasks/TaskList';
import { useStore } from '../../store/useStore';
import { getDepartmentLabel, getDepartmentIcon } from '../../utils/departments';
import { CheckCircle, Clock, ListTodo } from 'lucide-react';
import { motion } from 'framer-motion';

export const EmployeeTaskView: React.FC = () => {
  const currentUser = useStore((state) => state.currentUser);
  const tasks = useStore((state) => state.tasks);

  // Get tasks assigned to current user
  const userTasks = tasks.filter(task => task.assignedTo === currentUser?.id);
  
  const getTasksByStatus = (status: 'PENDING' | 'IN_PROGRESS' | 'COMPLETED') => {
    return userTasks.filter(task => task.status === status);
  };

  const DepartmentIcon = currentUser?.department ? getDepartmentIcon(currentUser.department) : ListTodo;

  return (
    <div className="space-y-6">
      <Card className="p-6">
        <div className="flex items-center gap-3 mb-6">
          <div className="p-2 bg-blue-100 rounded-lg">
            <DepartmentIcon className="w-5 h-5 text-blue-600" />
          </div>
          <div>
            <h2 className="text-lg font-semibold">
              {currentUser?.department ? getDepartmentLabel(currentUser.department) : ''} Tasks
            </h2>
            <p className="text-sm text-gray-600">Manage and track your assigned tasks</p>
          </div>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
          <div className="p-4 bg-gray-50 rounded-lg">
            <div className="flex items-center gap-2 mb-2">
              <Clock className="w-4 h-4 text-gray-600" />
              <h3 className="text-sm font-medium text-gray-700">Pending</h3>
            </div>
            <p className="text-2xl font-bold text-gray-900">{getTasksByStatus('PENDING').length}</p>
          </div>

          <div className="p-4 bg-gray-50 rounded-lg">
            <div className="flex items-center gap-2 mb-2">
              <ListTodo className="w-4 h-4 text-gray-600" />
              <h3 className="text-sm font-medium text-gray-700">In Progress</h3>
            </div>
            <p className="text-2xl font-bold text-gray-900">{getTasksByStatus('IN_PROGRESS').length}</p>
          </div>

          <div className="p-4 bg-gray-50 rounded-lg">
            <div className="flex items-center gap-2 mb-2">
              <CheckCircle className="w-4 h-4 text-gray-600" />
              <h3 className="text-sm font-medium text-gray-700">Completed</h3>
            </div>
            <p className="text-2xl font-bold text-gray-900">{getTasksByStatus('COMPLETED').length}</p>
          </div>
        </div>

        <div>
          <h3 className="text-sm font-medium text-gray-700 mb-4">Your Tasks</h3>
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.3 }}
          >
            <TaskList tasks={userTasks} showDepartment />
          </motion.div>
        </div>
      </Card>
    </div>
  );
};